import { DecisionType } from '../models';

export function isDisagreementReasonRequired(
  aiScore: number,
  decision: DecisionType,
): boolean {
  if (decision === 'block' && aiScore <= 4) return true;
  if (decision === 'approve' && aiScore >= 7) return true;
  return false;
}

export type AiLean = 'approve' | 'block' | 'neutral';

export function aiLeanFromScore(aiScore: number): AiLean {
  if (aiScore <= 4) return 'approve';
  if (aiScore >= 7) return 'block';
  return 'neutral';
}
